import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { ToasterModule, ToasterService } from 'angular2-toaster';
import { HttpClientModule } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
/* ScrollBar */
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';

/* Frola Editor */
import "froala-editor/js/froala_editor.pkgd.min.js";
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';


import { DragulaModule } from 'ng2-dragula';
import { MatTableDataSource, MatPaginator } from "@angular/material";
/* Material Modules
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';*/

/* Components */
import { AppComponent } from './app.component';
import { PucComponent } from './components/page-under-construction/puc.component';
import { SidenavComponent } from './components/common/sidenav/sidenav.component';
import { HeaderComponent } from './components/common/header/header.component';
import { FooterComponent } from './components/common/footer/footer.component';
import { AdmincontentComponent } from './components/admin-content/admincontent/admincontent.component';
import { SubnavComponent } from './components/common/sidenav/subnav/subnav.component';
import { LoginComponent } from './components/pages/login/login.component';
import { InvestorUserListComponent } from './components/pages/users/investor/listuser/investor-user-list.component';



/* Services */
import { UtilityService } from './services/utilities/utilities.services';
import { MenuService } from './services/utilities/menu.services';
import { LoginService } from './services/login/login.service';
import { ApiDataServices } from './services/apiservices/api.services';
/* Pipes */
import { ObjNgForPipe } from './pipes/objNgFor/objNgFor.pipe';


/* Application Routing Module */
import { HybseRoutingModule } from './modules/routing/app.routing.module';

/* Application Material Module */
import { HybseMaterialModule } from './modules/material/material.module';

import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

/* Directives */
import { VerticalscrollbarDirective } from './directives/scrollbar/verticalscrollbar.directive';

/* Redux Imports */
import { StoreModule } from '@ngrx/store';
import { hybseReducers } from './app.reducer';

import { TooltipModule } from "ngx-tooltip";
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { NgxEditorModule } from 'ngx-editor';



/* Configuration */
import { HybseConfig } from './config/hybse.config';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthenticationGuard } from './guards/auth.guard';
import { ListusersComponent } from './components/pages/users/admin/listusers/listusers.component';
import { AdduserComponent } from './components/pages/users/admin/adduser/adduser.component';
import { EdituserComponent } from './components/pages/users/admin/edituser/edituser.component';
import { UserService } from './services/user/user.service';
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { InvestorAddUserComponent } from './components/pages/users/investor/adduser/investor-add-user.component';
import { ApirequestService } from './services/apirequest/apirequest.service';
import { ApiurlsService } from './services/api-urls/apiurls.service';
import { ConfirmdialogComponent } from './components/common/dialog/confirmdialog.component';
import { LoaderComponent } from './components/common/loader/loader.component';
import { InvestorEditUserComponent } from './components/pages/users/investor/edituser/investor-edit-user.component';
import { StorageService } from './services/localstorage/storage.service';
import { TableComponent } from './components/common/table/table.component';
import { PaginationComponent } from './components/common/pagination/pagination.component';
import { LogsComponent } from './components/pages/users/logs/logs.component';
import { ParseuaPipe } from './pipes/utilities/parseua.pipe';
import { ActivityDetailsComponent } from './components/pages/users/logs/activity-details/activity-details.component';
import { IssuersComponent } from './components/pages/users/issuers/issuers.component';
import { IssuerAddUserComponent } from './components/pages/users/issuers/add-user/add-user.component';
import { IssuerEditUserComponent } from './components/pages/users/issuers/edit-user/edit-user.component';
import { CommonService } from './services/apiservices/common.service';
import { KycComponent } from './components/pages/kyc/kyc.component';
import { KycApproveRejectComponent } from './components/pages/kyc/kyc-approve-reject.component';
import { DemoBuyerSellerComponent } from './components/pages/users/investor/edituser/demo-buyer-seller.component';

// scroll bar
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { EditUserInfoComponent } from './components/pages/users/edit/edit-user-info.component';
import { OrderModule } from 'ngx-order-pipe';
import { NemTestComponent } from './components/pages/users/nem-test/nem-test.component';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    ObjNgForPipe,
    AppComponent,
    PucComponent,
    SidenavComponent,
    HeaderComponent,
    FooterComponent,
    AdmincontentComponent,
    VerticalscrollbarDirective,
    SubnavComponent,
    LoginComponent,
    ListusersComponent,
    AdduserComponent,
    EdituserComponent,
    InvestorUserListComponent,
    InvestorAddUserComponent,
    ConfirmdialogComponent,
    LoaderComponent,
    InvestorEditUserComponent,
    TableComponent,
    PaginationComponent,
    LogsComponent,
    ParseuaPipe,
    ActivityDetailsComponent,
    IssuersComponent,
    IssuerAddUserComponent,
    IssuerEditUserComponent,
    KycComponent,
    KycApproveRejectComponent,
    DemoBuyerSellerComponent,
    EditUserInfoComponent,
    NemTestComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    ToasterModule.forRoot(),
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    NgxEditorModule,
    HybseMaterialModule,
    MalihuScrollbarModule,
    DragulaModule,
    HybseRoutingModule,
    HttpClientModule,
    StoreModule.forRoot(hybseReducers),
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    TooltipModule,
    ToastModule.forRoot(),
    PerfectScrollbarModule,
    OrderModule

  ],
  entryComponents: [ConfirmdialogComponent, ActivityDetailsComponent, KycApproveRejectComponent,
    EditUserInfoComponent],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    HybseConfig,
    UtilityService,
    MenuService,
    ApiDataServices,
    LoginService,
    AuthenticationGuard,
    MalihuScrollbarService,
    UserService,
    ApirequestService,
    StorageService,
    ApiurlsService,
    CommonService,
    MatPaginator
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/app.module.ts